import { getOrderCount } from '@/apis/order'
import { getConsultUnreadCount, readConsult } from '@/apis/resource'
import { batchMessageRead, getMessageStatics } from '@/apis/user'
import { defineStore } from 'pinia'

export default defineStore('consultStore', {
  state: () => {
    return {
      consultInfo: {
        // 订单咨询
        unreadCount: 0, // 未读个数
        totalCount: 0, // 总个数
      },
      msgInfo: {
        // 站内信
        unreadCount: 0, // 未读个数
      },
      orderInfo: {
        waitPayCount: 0, // 待支付数
        confirmCount: 0, // 到确认数
        totalCount: 0, // 总个数
      },
    }
  },
  actions: {
    // 获取 站内信  未读个数
    async getMessageCount() {
      try {
        const res = await getMessageStatics({})
        res.total = res.systemUnread + res.otherUnread
        this.msgInfo = res
        this.msgInfo.unreadCount = res.unread
      } catch (error) {
        this.msgInfo.unreadCount = 0
      }
    },
    // 获取 咨询 未读个数
    async getConsultCount() {
      try {
        const res = await getConsultUnreadCount({})
        this.consultInfo.unreadCount = res.unread
        this.consultInfo.totalCount = res.total
      } catch (error) {
        this.consultInfo.unreadCount = 0
      }
    },
    // 阅读站内信
    async readMessage(ids) {
      try {
        await batchMessageRead(ids)
        setTimeout(() => {
          this.getMessageCount()
        }, 2000)
      } catch (error) {
        //
      }
    },
    // 已读 咨询
    async readConsult(params) {
      try {
        await readConsult(params)
        this.getConsultCount()
      } catch (error) {
        //
      }
    },
    // 更新信息相关的个数
    async updateAllMsgCount() {
      this.getConsultCount()
      this.getMessageCount()
      this.getOrderInfoCount()
    },
    // 获取订单信息
    async getOrderInfoCount() {
      const res = await getOrderCount({ delFlag: 0 })
      this.orderInfo.waitPayCount = res.waitPayCount + res.goodsFillCount + res.postageFillCount
      this.orderInfo.confirmCount = res.confirmCount
      this.orderInfo.totalCount = this.orderInfo.waitPayCount + res.confirmCount
    },
  },
  persist: {
    key: 'consultStore',
    storage: sessionStorage,
    paths: ['orderConsult', 'msgInfo'],
  },
})
